import { Link } from "react-router-dom";
import phone from "../../assets/icons/phone.png";
import { FOOTER } from "../../data/texts";

const XsFooter = ({ menuData = [] }) => {
  const data = FOOTER;
  const logos = data.logos;

  /**
   * تابع اصلاح مسیر برای هماهنگی با روت‌های فرانت‌بند
   */
  const getCleanPath = (rawUrl) => {
    if (!rawUrl) return "/";
    if (rawUrl.startsWith("http")) return rawUrl;

    const parts = rawUrl.split("/").filter(Boolean);
    if (parts.length === 0 || parts[0] === "home") return "/";

    return `/${parts[0]}`;
  };

  return (
    <div className="md:hidden bg-[#e5e5e5] pt-6 pb-10 px-5 -mb-5">
      <div className="flex flex-col items-center gap-5 text-center">
        {" "}
        <img src={data.logo} className="w-44 object-contain" alt="logo" />
        <p className="text-[13px] text-[#858585] text-center leading-7 px-2">
          {" "}
          {data.text}
        </p>
        <div className="flex flex-wrap justify-center items-center gap-x-8 gap-y-3">
          {" "}
          {/* نمایش داینامیک منو */}
          {menuData.map((m) => {
            const cleanPath = getCleanPath(m.url);
            const isExternal = cleanPath.startsWith("http");

            return isExternal ? (
              <a
                key={m.id}
                href={cleanPath}
                target="_self"
                rel="noreferrer"
                className="hover:text-[#038A86]"
              >
                {m.title}
              </a>
            ) : (
              <Link key={m.id} to={cleanPath} className="hover:text-[#038A86]">
                {m.title}
              </Link>
            );
          })}
          {/* لینک ثابت حریم خصوصی */}
        </div>
      </div>

      <div className="flex justify-center mt-4 text-[13px]">
        <div className="flex w-fit justify-center items-center gap-2 
        bg-white ps-3 rounded-full text-[#858585]">
          <a  href={`tel:${data.number1}`} className="cursor-pointer text-gray-900">
            {data.number1}
          </a>
          <span>و</span>
          <a  href={`tel:${data.number2}`} className="cursor-pointer text-gray-900">
            {data.number2}
          </a>
          <span className="bg-aqua rounded-full p-2">
            <img src={phone} width={15} alt="phone" />
          </span>
        </div>
      </div>

      <div className="flex justify-center items-center gap-2 mt-3">
        {" "}
        {logos.map((e, index) => {
          const isExternal = e.link?.startsWith("http");

          return isExternal ? (
            <a key={index} href={e.link} target="_self" rel="noreferrer">
              <img
                src={e.logo}
                width={60}
                className="object-contain"
                alt="trust-logo"
              />
            </a>
          ) : (
            <Link key={index} to={e.link || "#"}>
              <img
                src={e.logo}
                className="object-cover h-12 w-12 rounded-lg"
                alt="trust-logo"
              />
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default XsFooter;
